import React from 'react';
import { Range } from 'react-range';
import './Rangeput.css';

class Rangeput extends React.Component {



  /* when used with formik you have these props, which access to
  this.props.field, // { name, value, onChange, onBlur }
  this.props.form   // { touched, errors, values, setXXXX, handleXXXX, dirty, isValid, status, ...etc }.
   */
  constructor(props) {
    super(props);
    this.state = { values: props.values };
  }

  // input text change
  handleChange = (values) => {
    this.updateStateAndField(values);
  };

  handleMouseDown = event => {
    event.target.style.backgroundColor = "#7d7d7d";
    console.log(event.target.style.backgroundColor)
    window.addEventListener("mouseup", function x() {
      document.querySelectorAll(".rangeput-slider-thumb").forEach(element => {element.style.backgroundColor = "#FFFFFF"});
      window.removeEventListener("mouseup", x);
    })
  }
  handleMouseUp = event => {
    event.target.style.backgroundColor = "#FFFFFF";
  }

  handleHover = event => {
    event.target.style.backgroundColor = "#979797";
  }

  handleMouseLeave = event => {
    event.target.style.backgroundColor = "#FFFFFF";
  }
  handleMinValChange = event => {
    let newVal = event.target.value;
    if (0 < newVal && newVal < this.state.values[1]) {
      this.setState({ value: [newVal, this.state.values[1]] });
    }
  };

  handleMaxValChange = event => {
    this.updateStateAndField([this.state.values[1], event.target.value]);
  };


  // updates the field in Formik's internal representation
  updateStateAndField = (values) => {
    this.props.form.setFieldValue('budget', values);
    this.setState(values);
  };

  render() {

    return (
      <div className="rangeput-widget">
        <Range
          step={100}
          min={500}
          max={25000}
          values={this.state.values}
          onChange={values => { this.handleChange({ values }) }}
          renderTrack={({ props, children }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: '6px',
                width: '100%',
                backgroundColor: '#ccc'
              }}
            >
              {children}
            </div>
          )}
          renderThumb={({ props }) => (
            <div className="rangeput-slider-thumb" onMouseLeave={(e) => this.handleMouseLeave(e)} onMouseOver={(e) => this.handleHover(e)} onMouseDown={(e) => this.handleMouseDown(e)} onMouseUp={(e) => this.handleMouseUp(e)}
              {...props}
              style={{
                ...props.style,
                height: '42px',
                width: '42px',
                // backgroundColor: '#999'
              }}
            />
          )}
        />


        <div className="rangeput-numerical row">
          <div className={'rangeput-min col-sm-12 col-md-12 col-lg-6'}>
            <label className={'rangeput-min-label'}>{this.props.minLabel}</label>
            <div className={'chf-container'}>
              <input
                disabled="disabled"
                name="minBudget"
                type="number"
                value={this.state.values[0]}
                className="input-hide-browser-extras"
                //onChange={this.handleMinValNumericChange}
              />
            </div>
          </div>
          <div className={'rangeput-max  col-sm-12 col-md-12 col-lg-6'}> 
            <label className={'rangeput-max-label'}>{this.props.maxLabel}</label>
            <div className={'chf-container'}>
              <input
                disabled="disabled"
                name="maxBudget"
                type="number"
                value={this.state.values[1]}
                className="input-hide-browser-extras"
                //onChange={this.handleMaxValNumericChange}
              />
            </div>
          </div>
        </div>
      </div>
      
    );
  }
}
export default Rangeput;
